import { readBuildTimeVar } from './build-time-var';

declare const DEPLOY_URL: string | undefined;

export const deployUrl = (): string => readBuildTimeVar(() => DEPLOY_URL, '/');
